export default class SiteMenu {

    constructor(app) {
        this.className = 'c-site-menu'
        this.tl = null
        this.app = app
        this.delta = 6
        this.lastScroll = 0
        this.DOM = {};
        this.initDomElements();
        this.iniEvents();

    }

    initDomElements() {
        this.$el = document.querySelector('.' + this.className)
        this.DOM = {}
        this.DOM.burger = this.$el.querySelector('.' + this.className + '__burger')
        this.DOM.navMobile = this.$el.querySelector('.' + this.className + '__nav-list')
        this.DOM.links = this.$el.querySelectorAll('.' + this.className + '__nav-list >li')
        this.DOM.navRight = this.$el.querySelector('.' + this.className + '__nav-right')

        // Debug: Check if elements are found
        console.log('SiteMenu elements:', {
            burger: this.DOM.burger,
            navMobile: this.DOM.navMobile,
            links: this.DOM.links,
            navRight: this.DOM.navRight
        });
    }
    iniEvents() {
        this.DOM.burger.addEventListener('click', () => {
            // Kill any existing timeline
            if (this.tl) {
                this.tl.kill();
            }

            this.tl = this.app.gsap.timeline({ paused: true })
            this.DOM.burger.classList.toggle('active')
            const active = this.$el.classList.toggle('opened')

            if (active) {
                this.app.emit('disable-scroll')
                this.app.gsap.set(this.DOM.navRight, { visibility: 'visible' })

                // Désactiver les interactions du burger pendant l'animation
                this.tl.to(this.DOM.burger, { pointerEvents: "none", duration: 0 })

                // Animation simultanée de la nav mobile et nav right
                this.tl.fromTo([this.DOM.navMobile, this.DOM.navRight],
                    {
                        transform: 'translateX(100%)',
                        autoAlpha: 0
                    },
                    {
                        transform: 'translateX(0)',
                        autoAlpha: 1,
                        duration: 1.2,
                        ease: "0.14, 1.00, 0.34, 1.00"
                    }
                )

                // Animation des liens après l'ouverture complète de la nav
                this.tl.fromTo(this.DOM.links,
                    {
                        x: -30,
                        autoAlpha: 0
                    },
                    {
                        x: 0,
                        autoAlpha: 1,
                        duration: 0.8,
                        ease: "0.14, 1.00, 0.34, 1.00",
                        stagger: 0.1
                    },
                    "-=0.3"
                )

                // Réactiver les interactions du burger
                this.tl.to(this.DOM.burger, { pointerEvents: "all", duration: 0 })
            } else {
                // Désactiver les interactions du burger pendant l'animation
                this.tl.to(this.DOM.burger, { pointerEvents: "none", duration: 0 })

                // Animation simultanée de fermeture de la nav mobile et nav right
                this.tl.to([this.DOM.navMobile, this.DOM.navRight],
                    {
                        transform: 'translateX(100%)',
                        autoAlpha: 0,
                        duration: 0.8,
                        ease: "0.14, 1.00, 0.34, 1.00"
                    }
                )

                // Réactiver les interactions du burger
                this.tl.to(this.DOM.burger, { pointerEvents: "all", duration: 0 })
                this.app.emit('enable-scroll')
            }

            this.tl.play();
        })

        this._onAnyLinkClick = (e) => {
            const a = e.target.closest('a');
            if (!a) return;
            if (document.activeElement) document.activeElement.blur();
            this.$el.querySelectorAll(':focus').forEach((el) => el.blur?.());
            if (this.$el.classList.contains('opened')) {
                this.$el.classList.remove('opened');
                this.DOM.burger.classList.remove('active');
                this.app.gsap.set([this.DOM.navMobile, this.DOM.navRight], {
                    transform: 'translateX(100%)',
                    autoAlpha: 0
                });
                this.app.emit('enable-scroll');
            }
        };
        this.$el.addEventListener('click', this._onAnyLinkClick, true);

        if (!document.body.classList.contains('template-customer-cases') &&
            !document.body.classList.contains('template-articles')) {

            // 1) Locomotive (smooth:true)
            if (this.app?.$scroll?.scroll?.on) {
                this.app.$scroll.scroll.on('scroll', (args) => {
                    const y = args?.scroll?.y ?? 0
                    this.updateByY(y)
                })
            }

            // 2) Fallback natif
            this.handleScroll = () => this.updateByY(window.scrollY || 0)
            this.handleScroll() // init
            this.app.on('scroll', this.handleScroll)

        } else {
            // Variante noBg
            if (this.app?.$scroll?.scroll?.on) {
                this.app.$scroll.scroll.on('scroll', (args) => {
                    const y = args?.scroll?.y ?? 0
                    this.updateByY(y)
                })
            }
            this.handleScrollNoBg = () => this.updateByY(window.scrollY || 0)
            this.handleScrollNoBg()
            this.app.on('scroll', this.handleScrollNoBg)
        }


    }
    updateByY(y) {
        // anti-jitter direction
        if (Math.abs(y - this.lastScroll) <= this.delta) return

        const goingUp = y < this.lastScroll

        if (goingUp) {
            this.$el.classList.add('--scrolltop')
            this.$el.classList.remove('--scrolling')
        } else {
            if (y > 20) this.$el.classList.add('--scrolling')
            else this.$el.classList.remove('--scrolling')
            this.$el.classList.remove('--scrolltop')
        }

        this.lastScroll = y
    }
    handleScrollNoBg() {
        if (window.scrollY > this.lastScroll) {
            this.$el.classList.remove("--scrolltop");
        } else if (window.scrollY < this.lastScroll) {
            this.$el.classList.add("--scrolltop");
        }
        if (window.scrollY > 20) {
            this.$el.classList.add("--scrolling");
        } else {
            this.$el.classList.remove("--scrolling");
        }
        this.lastScroll = window.scrollY;
    }

    handleScroll() {
        if (window.scrollY > this.lastScroll) {
            this.$el.classList.remove("--scrolltop"
            );
        } else if (window.scrollY < this.lastScroll) {
            this.$el.classList.add("--scrolltop"
            );
        }
        if (window.scrollY > 20) {
            this.$el.classList.add("--scrolling"
            );
        } else {
            this.$el.classList.remove("--scrolling");
        }
        this.lastScroll = window.scrollY
    }

    refresh() {
        // Détacher les anciens événements
        this.destroy();
        
        // Réinitialiser les éléments DOM après mise à jour du menu
        this.initDomElements();
        
        // Réattacher les événements
        this.iniEvents();
    }

    destroy() {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._onAnyLinkClick && this.$el) {
            this.$el.removeEventListener('click', this._onAnyLinkClick, true);
        }
        
        // Détacher les événements de scroll
        if (this.handleScroll) {
            this.app.off('scroll', this.handleScroll);
        }
        if (this.handleScrollNoBg) {
            this.app.off('scroll', this.handleScrollNoBg);
        }
    }
}
